import { apiInstance } from '@/shared/api'

import type { CountriesList } from './types'

import { GET_COUNTRIES_LIST } from './constants'

export function getCountriesList() {
    return apiInstance.get(`${GET_COUNTRIES_LIST}`).json<CountriesList>()
}
